import BaseButton, { NCRBaseButtonProps } from '../base-button/base-button';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';
import { IconType, MuiIcon } from '../mui-icon/mui-icon';

export const IconButton: React.FC<Props> = ({
  icon,
  iconProps,
  children,
  ...props
}: Props): JSX.Element => {
  return (
    <BaseButton isSquare {...props}>
      {children}
      {icon && <MuiIcon iconKey={icon as keyof IconType} {...iconProps} />}
    </BaseButton>
  );
};

interface Props extends NCRBaseButtonProps {
  icon: string;
  iconProps?: SvgIconProps;
}
